export default __webpack_public_path__ + "static/media/team.89824e7d.svg";